/*
 * @Author: Yun
 * @Date: 2023-11-29 15:52:26
 * @Last Modified by: Yun
 * @Last Modified time: 2024-02-26 17:41:55
 */
import React from 'react'
import title from '@images/firstPage/title.png'
import txt from '@images/firstPage/txt.png'
import icon from '@images/firstPage/icon.png'
import './index.less'

const PREFIX = 'first-page'

const FirstPage = (props) => {
    const { id } = props

    return (
        <section className={PREFIX} id={id}>
            <img className={`${PREFIX}-img ${PREFIX}-title`} src={title} alt="" />
            <img className={`${PREFIX}-img ${PREFIX}-txt`} src={txt} alt="" />
            <img className={`${PREFIX}-img ${PREFIX}-icon`} src={icon} alt="" />
        </section>
    )
}

export default FirstPage
